<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">User input</h3>
        <div class="caption grey--text">{{responsename}}</div>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <!-- <div style="display:none">{{responsecard.index}}</div> -->
    <v-container grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="responsecard.card.message.text"
                label="Request user"                
                placeholder="Ask user what you needs"
                counter="2000"
                rows="1"
                v-on:keyup.shift.219="cusevent"
                class="body-1 font-weight-regular"
              ></v-textarea>                                                     
            </v-flex>                        
            </v-layout> 
            <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="responsecard.card.savetovar"
                label="Save to"                
                placeholder="Give the variable name to save"
                counter="50"
                rows="1"
                v-on:keyup.shift.219="cusevent"
                class="body-1 font-weight-regular"
              ></v-textarea>                                                     
            </v-flex>                        
            </v-layout>
            <v-layout class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-select                 
                    :items="qroptions"
                    label="Enable quick replies as input"
                    v-model="responsecard.card.qr_userinput"
                    hint="Free text input for the user still allowed even if quick replies enabled"
                ></v-select>                                                    
              </v-flex>                        
            </v-layout>
            <v-layout class="mt-0" row wrap>                       
              <v-card class="mt-4" flat style="border-radius: 8px;">
                <template v-for="(quickreply,qrindex) in responsecard.card.message.quick_replies" >
                  <v-chip  @mouseover="showqrbuttons(qrindex)" :key="qrindex" small color="blue-grey lighten-5">
                      <div v-if="quickreply.content_type == 'user_phone_number'">User Phone number</div>
                      <div v-if="quickreply.content_type == 'user_email'">User Email</div>
                      <div v-if="quickreply.content_type == 'text'">{{quickreply.title}}</div>
                      <v-btn class="mr-0" v-if="qrindex == quickreplyindex" flat icon small @click="editquickreply(qrindex)"><v-icon small color="grey">edit</v-icon></v-btn>
                      <v-btn class="mr-0" v-if="qrindex == quickreplyindex" flat icon small @click="deletequickreply(qrindex)"><v-icon small color="grey">delete</v-icon></v-btn>
                  </v-chip>
                </template>
                <v-btn v-if="responsecard.card.qr_userinput == 'Yes'" round flat outline small color="primary" @click="createQuickreply">+ Create Quick reply</v-btn>
              </v-card>                        
            </v-layout>
            <v-layout v-if="qrcreate == 'Yes' && responsecard.card.qr_userinput == 'Yes'" class="mt-2" row wrap>                       
              <v-flex class="mt-0" xs6>
                <v-select                 
                    :items="qrtypes"
                    label="Quickreply type"
                    v-model="qrtype"
                ></v-select>
                <v-textarea
                v-if="qrtype =='Text'"
                auto-grow
                v-model="qrtext"
                label="Quick reply text"                
                placeholder="Give the text"
                counter="20"
                rows="1"
                v-on:keyup.shift.219="cusevent"
                class="body-1 font-weight-regular"
              ></v-textarea> 
              <v-card v-if="qrtype =='User Phone number'" flat class="caption grey--text">
                <p>**User phone number will be extracted from Facebook profile, If not found the Quickreply will not be visible</p>
              </v-card>
              <v-card v-if="qrtype =='User email'" flat class="caption grey--text">
                <p>**User email will be extracted from Facebook profile, If not found the Quickreply will not be visible</p>
              </v-card>                                                    
              </v-flex> 
              <v-flex xs2>
              </v-flex>
              <v-flex class="mt-4" xs2>
                <v-card flat class="mt-4">
                  <v-btn  v-if="qrcreate == 'Yes'" class="mt-2" round flat outline small color="primary" @click="addQuickreply">Add</v-btn>
                  <!-- <v-btn  v-if="qrupdate  == 'Yes'" class="mt-2" round flat outline small color="primary" @click="updateQuickreply">Update</v-btn> -->
                </v-card>
              </v-flex>                       
            </v-layout> 
            <v-layout v-if="qrupdate == 'Yes' && responsecard.card.qr_userinput == 'Yes'" class="mt-2" row wrap>                       
              <v-flex class="mt-0" xs6>
                <v-select                 
                    :items="qrtypes"
                    label="Quickreply type"
                    v-model="qrtype"
                ></v-select>
                <v-textarea
                v-if="qrtype =='Text'"
                auto-grow
                v-model="qrtext"
                label="Quick reply text"                
                placeholder="Give the text"
                counter="20"
                rows="1"
                v-on:keyup.shift.219="cusevent"
                class="body-1 font-weight-regular"
              ></v-textarea> 
              <v-card v-if="qrtype =='User Phone number'" flat class="caption grey--text">
                <p>**User phone number will be extracted from Facebook profile, If not found the Quickreply will not be visible</p>
              </v-card>
              <v-card v-if="qrtype =='User email'" flat class="caption grey--text">
                <p>**User email will be extracted from Facebook profile, If not found the Quickreply will not be visible</p>
              </v-card>                                                    
              </v-flex> 
              <v-flex xs2>
              </v-flex>
              <v-flex class="mt-4" xs2>
                <v-card flat class="mt-4">
                  <!-- <v-btn  v-if="qrcreate == 'Yes'" class="mt-2" round flat outline small color="primary" @click="addQuickreply">Add</v-btn> -->
                  <v-btn  v-if="qrupdate  == 'Yes'" class="mt-2" round flat outline small color="primary" @click="updateQuickreply">Update</v-btn>
                </v-card>
              </v-flex>                       
            </v-layout>                 
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>  
        </v-card>
</template>

<script>
import Vue from 'vue'
export default {
  data(){
    return{
      text:null,
      type:"text",
      qrtype:null,
      qrcreate:"No",
      qrupdate:"No",
      qrtext:null,
      qroptions:["Yes","No"],
      qrtypes:["Text","User Phone number","User email"],
      qrcreate:"No",
      qrupdate:"No",
      quickreplyindex:null,
      quickreplyupdateindex:null,
    }
  },
  methods:{
    saveCard(){
      let message = this.responsecard.card.message
      let textmessage
      let qr_userinput = "No"
      if (message.quick_replies && message.quick_replies.length > 0){
        qr_userinput = "Yes"
        textmessage = {"text":message.text, "quick_replies":message.quick_replies}
      }
      else {
        textmessage = {"text":message.text }
      }
      let editedresponse = {"message":textmessage,"type":"userinput","savetovar":this.responsecard.card.savetovar,"qr_userinput":qr_userinput}      
      this.$store.dispatch('aSaveEditedresponseMessage', {editedresponse})
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
     
    },
    cancelCard(){
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    cusevent(){
      console.log("event triggered")
    },
    showqrbuttons(qrindex){
    this.quickreplyindex = qrindex 
    },
    createQuickreply(){
      this.qrcreate = "Yes"
      this.qrupdate = "No"
      this.qrtext = null
      this.qrtype = "text"
    },
    addQuickreply(){
      let quickreply  
      if(this.qrtype == 'User Phone number')
      {
        quickreply = {"content_type":"user_phone_number"}  
      }
      else if (this.qrtype == 'User email')
      {
        quickreply = {"content_type":"user_email"} 
      }
      else if(this.qrtype == 'Text')
      {
        quickreply =  {
                  "content_type":"text",
                  "title":this.qrtext,
                  "payload":"save_quick_reply_text"
                }
      } 
      if(this.responsecard.card.message.quick_replies)  {       
      this.responsecard.card.message.quick_replies.push(quickreply)
      }
      else{
        Vue.set(this.responsecard.card.message, 'quick_replies', [])  
        this.responsecard.card.message.quick_replies.push(quickreply)
      }
      console.log(this.responsecard.card.message.quick_replies)
      this.qrcreate = "No"
      this.qrtext = null
      this.qrtype = "text"
    },
    editquickreply(qrindex){
      this.qrupdate = "Yes"
      this.qrcreate = "No"
      this.quickreplyupdateindex = qrindex
      console.log(qrindex)
      console.log(this.responsecard.card.message.quick_replies[qrindex])
      if(this.responsecard.card.message.quick_replies[qrindex].content_type == 'text')
      {
        this.qrtype = "Text"
        this.qrtext = this.responsecard.card.message.quick_replies[qrindex].title
      }
      else if (this.responsecard.card.message.quick_replies[qrindex].content_type == 'user_phone_number')
      {
        this.qrtype = "User Phone number"
        this.qrtext = null
      }
      else if (this.responsecard.card.message.quick_replies[qrindex].content_type == 'user_email')
      {
        this.qrtype = "User email"
        this.qrtext = null
      }
    },
    updateQuickreply(){
      let quickreply  
      if(this.qrtype == 'User Phone number')
      {
        quickreply = {"content_type":"user_phone_number"}  
      }
      else if (this.qrtype == 'User email')
      {
        quickreply = {"content_type":"user_email"} 
      }
      else if(this.qrtype == 'Text')
      {
        quickreply =  {
                  "content_type":"text",
                  "title":this.qrtext,
                  "payload":"save_quick_reply_text"
                }
      }          
      this.responsecard.card.message.quick_replies.splice(this.quickreplyupdateindex,1,quickreply)
      console.log(this.responsecard.card.message.quick_replies)
      this.qrcreate = "No"
      this.qrupdate = "No"
      this.qrtext = null
      this.qrtype = "text"
      this.quickreplyupdateindex = null
    },
    deletequickreply(qrindex){
         this.responsecard.card.message.quick_replies.splice(qrindex,1)
    }
  },
  computed:{
      responsename(){
      let index = this.$store.state.currentResponseIndex
      let rname = this.$store.state.responses[index].name
      return rname   
    },
    responsecard(){
      //this.text = this.$store.state.cardEditor.card.message.text
      return this.$store.state.cardEditor
    }
  }
}
</script>
